import React, { useState } from 'react';
import BeaconComparableSplineChart from 'src/components/BeaconV2Components/BeaconMetricSplineChart/BeaconComparableSplineChart';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import BuyBoxWinRateByProductGrid from './BuyBoxWinRateByProductGrid';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';
import BuyBoxByWeekGrid from 'src/components/BeaconV2Components/ExperimentalLayout/BuyBox/Summary/BuyBoxByWeekGrid';
import { ChartContextProvider } from 'src/utils/chartContext/ChartContextGroupContext';
import { CHART_CONTEXT_GROUPS, CHART_NAMES } from 'src/utils/chartContext/chartContextRegistry';

/**
 * Displays visualizations for the buy box summary page
 */
const BuyBoxSummaryPage = () => {
  const [fieldName, setFieldName] = useState('winPercentage');
  const entityType = useMainEntityType();

  return (
    <BasePageContainer>
      <Flex gap={BEACON_CHART_SPACING} flexDirection="column">
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_BUYBOX_WIN_RATE.name}
          chartName={CHART_NAMES.BEACON_BUYBOX_WIN_RATE_SPLINE}
        >
          <BeaconComparableSplineChart
            indexName="buybox"
            fieldName={fieldName}
            singleDropdownProps={{
              defaultLabel: '',
              options: [
                {
                  id: 'winPercentage',
                  label: 'Win Rate'
                },
                {
                  id: 'lossPercentage',
                  label: 'Loss Rate'
                }
              ],
              selectedId: fieldName,
              onChange: (option) => setFieldName(option.id)
            }}
          />
        </ChartContextProvider>
        {entityType !== 'product' && <BuyBoxWinRateByProductGrid />}
        {entityType === 'product' && (
          <BuyBoxByWeekGrid
            gridTitle="Win Rate by Week"
            fields={[
              {
                name: 'buyBoxWeighted',
                displayInTable: false,
                comparisonFormatter: () => null
              },
              {
                name: 'winsByClient',
                displayInTable: false,
                comparisonFormatter: () => null
              },
              {
                name: 'winPercentage',
                displayName: 'Buy Box - Win Rate',
                comparisonFormatter: () => null
              },
              {
                name: 'lossPercentage',
                displayName: 'Buy Box - Loss Rate',
                comparisonFormatter: () => null
              }
            ]}
          />
        )}
      </Flex>
    </BasePageContainer>
  );
};

export default BuyBoxSummaryPage;
